// extracted by mini-css-extract-plugin
export default {"title":"style_title__vHJzy","categoryItem":"style_categoryItem__3lzt0","imgBlock":"style_imgBlock__bi1ko","activeCategory":"style_activeCategory__y25AS"};